<script>
  import { format } from 'svelte-i18n';

  import { Field, FieldActions, FieldHeader, FieldLabel, FieldValue } from '@client/components/fields/standalone/base';
  import { Select } from '@client/components/select';

  export let id = null;
  export let label = null;
  export let selected = null;
  export let options = [];
  export let placeholder = $format('label.PLACEHOLDER.SELECT');
  export let formatValue = (val) =>
    val
      ?.filter((item) => item.checked)
      .map(({ label }) => label)
      .join(', ') || '-';

  export let tooltip = undefined;
  export let tooltipIcon = undefined;

  export let readonly = false;
  export let editing = false;

  export let onUpdate = () => {};

  let items = [...options];
  let selectedValues = [...selected];
  let selectedValuesIds = [];
  let disableSubmit = true;

  export let showActions = true;

  const onEdit = () => {
    editing = true;
  };

  const onCancel = () => {
    editing = false;

    selectedValues = selected;
    selectedValuesIds = selectedValues.map((item) => item.value);

    items = items.map((item) => {
      item.checked = selectedValuesIds.includes(item.value);

      return item;
    });
  };

  const onSave = () => {
    editing = false;
    selected = selectedValues;

    if (onUpdate) {
      onUpdate(id, label, items);
    }
  };

  const onClear = ({ detail }) => {
    if (detail instanceof Array) {
      selectedValues = [];
    } else {
      items = items.map((item) => {
        if (item.value === detail.value) {
          item.checked = false;
        }

        return item;
      });

      selectedValues = items.map((item) => item.checked && item).filter(Boolean);
    }
  };

  const onSelect = ({ detail = [] }) => {
    const selectedItems = detail;

    selectedValues = selectedItems.map((item) => (item.checked = true) && item).filter(Boolean);
    selectedValuesIds = selectedValues.map((item) => item.value);

    items = items.map((item) => {
      item.checked = selectedValuesIds.includes(item.value);

      return item;
    });
  };

  $: disableSubmit = JSON.stringify(selectedValues) === JSON.stringify(selected);
  $: items = [...options];
  $: selectedValues = [...selected];
</script>

<Field bind:editing>
  <FieldHeader>
    <FieldLabel {label} {tooltipIcon} {tooltip} />
    <FieldActions bind:readonly bind:editing bind:disableSubmit {onSave} {onEdit} {onCancel} {showActions} />
  </FieldHeader>
  <FieldValue {showActions}>
    <span class="field-multiselect">
      {#if editing}
        <Select
          multiple
          placeholderAlwaysShow
          {placeholder}
          bind:items
          value={selectedValues}
          on:change={onSelect}
          on:clear={onClear}
        />
      {:else}
        <slot {selectedValues}>{formatValue(selectedValues)}</slot>
      {/if}
    </span>
  </FieldValue>
  {#if !editing && $$slots.preview}
    <slot name="preview" {selectedValues} />
  {/if}
</Field>

<style lang="scss" src="./multi-select.scss"></style>
